export class OutputBase {
	ok: {
		/**
		 * text message
		 */
		message?: string,
		/**
		 * JSON
		 */
		data?: {},
	}
	error?: {
		/**
		 * error code
		 * see
		 */
		code?: string,
		/**
		 * text message
		 */
		message?: string,
		/**
		 * JSON
		 */
		data?: {},
	}
}